import { createSlice } from '@reduxjs/toolkit';
import {
  createPfWithdrawal,
  fetchAllPfWithdrawals,
  fetchPfWithdrawalById,
  updatePfWithdrawal,
  deletePfWithdrawal
} from './pfWithdrawalActions';
import { PfWithdrawalState } from './pfWithdrawalTypes';

const initialState: PfWithdrawalState = {
  records: [],
  selectedRecord: undefined,
  loadingStates: {
    create: false,
    fetchAll: false,
    fetchById: false,
    update: false,
    delete: false
  },
  errors: {}
};

const pfWithdrawalSlice = createSlice({
  name: 'pfWithdrawal',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create
      .addCase(createPfWithdrawal.pending, (state) => {
        state.loadingStates.create = true;
        state.errors.create = undefined;
      })
      .addCase(createPfWithdrawal.fulfilled, (state, action) => {
        state.loadingStates.create = false;
        state.records.push(action.payload.data);
      })
      .addCase(createPfWithdrawal.rejected, (state, action) => {
        state.loadingStates.create = false;
        state.errors.create = action.payload as string;
      })

      // Fetch All
      .addCase(fetchAllPfWithdrawals.pending, (state) => {
        state.loadingStates.fetchAll = true;
        state.errors.fetchAll = undefined;
      })
      .addCase(fetchAllPfWithdrawals.fulfilled, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.records = action.payload.data;
      })
      .addCase(fetchAllPfWithdrawals.rejected, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.errors.fetchAll = action.payload as string;
      })

      // Fetch By ID
      .addCase(fetchPfWithdrawalById.pending, (state) => {
        state.loadingStates.fetchById = true;
        state.errors.fetchById = undefined;
      })
      .addCase(fetchPfWithdrawalById.fulfilled, (state, action) => {
        state.loadingStates.fetchById = false;
        state.selectedRecord = action.payload.data;
      })
      .addCase(fetchPfWithdrawalById.rejected, (state, action) => {
        state.loadingStates.fetchById = false;
        state.errors.fetchById = action.payload as string;
      })

      // Update
      .addCase(updatePfWithdrawal.pending, (state) => {
        state.loadingStates.update = true;
        state.errors.update = undefined;
      })
      .addCase(updatePfWithdrawal.fulfilled, (state, action) => {
        state.loadingStates.update = false;
        const index = state.records.findIndex(
          (rec) => rec.pfWithdrawalId === action.payload.id
        );
        if (index !== -1) {
          state.records[index] = {
            ...action.payload.data,
            pfWithdrawalId: action.payload.id
          };
        }
      })
      .addCase(updatePfWithdrawal.rejected, (state, action) => {
        state.loadingStates.update = false;
        state.errors.update = action.payload as string;
      })

      // Delete
      .addCase(deletePfWithdrawal.pending, (state) => {
        state.loadingStates.delete = true;
        state.errors.delete = undefined;
      })
      .addCase(deletePfWithdrawal.fulfilled, (state, action) => {
        state.loadingStates.delete = false;
        state.records = state.records.filter(
          (record) => record.pfWithdrawalId !== action.payload
        );
      })
      .addCase(deletePfWithdrawal.rejected, (state, action) => {
        state.loadingStates.delete = false;
        state.errors.delete = action.payload as string;
      });
  }
});

export default pfWithdrawalSlice.reducer;
